import { finalizeRoundBet, playGame } from "./gameService";
import { gameStates } from "./gameStates";
import { gameAssets, handleGameState, ShowInsufficientBalancePopup } from "./gameUI";
import { globalData } from "./globalData";

export function processSpinResult() {
    if (globalData.currentGameState === gameStates.IDLE) {
        if (globalData.balance < globalData.totalBet) {
            ShowInsufficientBalancePopup();
            globalData.autoplay = false;
            globalData.turbo = 0;

            gameAssets.speedLinesFx.visible = false;

            gameAssets.autoplayEnabled.visible = false;
            gameAssets.turboEnabled.visible = false;
            gameAssets.menubarButton.tint = 0xffffff;
            gameAssets.menubarButton.interactive = true;

            if (gameAssets.turboJeepney.visible) {
                gameAssets.transition.state.setAnimation(0, "front_turbo2_off", false).listener = {
                    complete: () => {
                        gameAssets.turboJeepney.visible = false;
                        gameAssets.speedLinesFx.visible = false;
                        gameAssets.jeepney.visible = true;
                        gameAssets.jeepney.state.timeScale = 1;
                        gameAssets.jeepney.state.setAnimation(0, "front", true);
                    }
                }
            } else if (gameAssets.autoJeepney.visible) {
                gameAssets.autoJeepney.visible = false;
                gameAssets.jeepney.visible = true;
                gameAssets.jeepney.state.timeScale = 1;
                gameAssets.jeepney.state.setAnimation(0, "front", true);
            }
        }
        else {
            finalizeRoundBet();
            globalData.currentGameState = gameStates.ROUND_START;
        }
        return;
    }
    if (globalData.currentGameState === gameStates.ROUND_START) {
        globalData.currentGameState = gameStates.ROUND_CONTINUE;
        playGame();
        return;
    }
    if (globalData.currentGameState === gameStates.ROUND_CONTINUE) {
        globalData.currentGameState = gameStates.ROUND_END;
        handleGameState(globalData.currentGameState);
        return;
    }

    if (globalData.currentGameState === gameStates.ROUND_END && globalData.currentRound < globalData.totalRounds && globalData.gameResult === "pending") {
        globalData.currentGameState = gameStates.ROUND_START;
        handleGameState(globalData.currentGameState);
        return;
    }
    if (globalData.currentGameState === gameStates.ROUND_END) {
        if (globalData.gameResult === "won" || globalData.gameResult === "lost") {
            globalData.currentGameState = gameStates.RESULT;
            handleGameState(globalData.currentGameState);
            return;
        }
    }
    if (globalData.currentGameState === gameStates.ROUND_END) {
        globalData.currentGameState = gameStates.RESULT;
        handleGameState(globalData.currentGameState);
        return;
    }
    if (globalData.currentGameState === gameStates.RESULT) {
        globalData.currentGameState = gameStates.IDLE;
        handleGameState(globalData.currentGameState);
        return;
    }
}